export default __webpack_public_path__ + "static/media/banner-3.09a0d84c.jpg";